export const combinColumns = [
  {
    title: "组合处理编号",
    dataIndex: "packCode",
    key: "packCode",
  },
  {
    title: "订单号",
    dataIndex: "platformOrderNo",
    key: "platformOrderNo",
  },
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    scopedSlots: {
      customRender: "productImg",
    },
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "商品sku",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "规格",
    dataIndex: "productProp",
    key: "productProp",
  },
  {
    title: "已组合/组合数量",
    dataIndex: "amount",
    key: "amount",
    customRender: (text, record) => {
      return `${record.combinedAmount}/${record.amount}`
    },
  },
  {
    title: "组合状态",
    dataIndex: "status",
    key: "status",
    customRender: (text, record) => {
      return text == 0
        ? "待处理"
        : text == 1
        ? "组合中"
        : text == 2
        ? "已完成"
        : "";
    },
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    width:150,
    fixed:'right',
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const goodsColumns = [
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    scopedSlots: {
      customRender: "shipmentCodeAction",
    },
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "商品sku",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "规格",
    dataIndex: "productProp",
    key: "productProp",
  },
  {
    title: "单组数量",
    dataIndex: "unitAmount",
    key: "unitAmount",
  },
  {
    title: "质检上架数",
    dataIndex: "checkingShelvedAmount",
    key: "checkingShelvedAmount",
  },
  {
    title: "成品上架数",
    dataIndex: "checkedShelvedAmount",
    key: "checkedShelvedAmount",
  },
];

export const detailColumns = [
  {
    title: "操作时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "批次编码",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "包类型",
    dataIndex: "status",
    key: "status",
    customRender:(text,record)=>{
      // return text
      return text==0?'':text==1?'正品':''
    }
  },
  {
    title: "商品SKU",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "订单编号",
    dataIndex: "orderCode",
    key: "orderCode",
  },
  // {
  //   title: "组合单号",
  //   dataIndex: "modifier",
  //   key: "modifier",
  // },
  {
    title: "件数",
    dataIndex: "amount",
    key: "amount",
  },
  // {
  //   title: "打印标签",
  //   dataIndex: "id",
  //   key: "id",
  //   scopedSlots: {
  //     customRender: "print",
  //   },
  // },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const inspectColumns = [
  {
    title: "组合处理编号",
    dataIndex: "packCode",
    key: "packCode",
  },
  {
    title: "订单编号",
    dataIndex: "platformOrderNo",
    key: "platformOrderNo",
  },
  // {
  //   title: "组合状态",
  //   dataIndex: "status",
  //   key: "status",
  //   customRender: (text, record) => {
  //     return text == 0
  //       ? "待处理"
  //       : text == 1
  //       ? "组合中"
  //       : text == 2
  //       ? "已完成"
  //       : "";
  //   },
  // },
  {
    title: "本次组合量",
    dataIndex: "packableAmount",
    key: "packableAmount",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const inspectRegionColumns = [
  {
    title: "序号",
    dataIndex: "index",
    key: "index",
    customRender: (text, record,index) => {
      return index + 1
    },
  },
  {
    title: "拣货库区",
    dataIndex: "regionName",
    key: "regionName",
  },
  {
    title: "拣货数量",
    dataIndex: "nums",
    key: "nums",
  },
]

export const inspectGoodsColumns = [
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    scopedSlots: {
      customRender: "img",
    },
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "商品sku",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "商品规格",
    dataIndex: "productProp",
    key: "productProp",
  },
  // {
  //   title: "库存数量",
  //   dataIndex: "checkingShelvedAmount",
  //   key: "checkingShelvedAmount",
  // },
  {
    title: "单组数量",
    dataIndex: "unitAmount",
    key: "unitAmount",
  },
  {
    title: "本次使用数量",
    dataIndex: "useAmount",
    key: "useAmount",
    // customRender: (text, record) => {
    //   return record.packableAmount * record.unitAmount
    // },
  },
];
export const moveColumns = [
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    scopedSlots: {
      customRender: "img",
    },
  },
  {
    title: "原批次包编码",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "新批次包编码",
    dataIndex: "newPkgCode",
    key: "newPkgCode",
  },
  {
    title: "商品名称",
    dataIndex: "productName",
    key: "productName",
  },
  {
    title: "商品sku",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "规格",
    dataIndex: "productProp",
    key: "productProp",
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    customRender: (text, record) => {
      return text == 0 ? "待调拨" : text == 1 ? "调拨拣货中" : text == 2 ? "调拨完成" : "";
    },
  },
  {
    title: "待调拨数量",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    fixed: 'right',
    width: 200,
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const taskColumns = [
  {
    title: "组合处理编号",
    dataIndex: "packCode",
    key: "packCode",
  },
  {
    title: "订单编号",
    dataIndex: "platformOrderNo",
    key: "platformOrderNo",
  },
  {
    title: "任务状态",
    dataIndex: "status",
    key: "status",
    customRender: (text, record) => {
      return text == 0 ? "未完成" : text == 1 ? "已完成" : "";
    },
  },
  {
    title: "组合进度",
    dataIndex: "progress",
    key: "progress",
    customRender: (text, record) => {
      return `${record.combinedAmount || '0'}/${record.amount || '0'}`
    },
  },
  {
    title: "分拣框",
    dataIndex: "pickBox",
    key: "pickBox",
    scopedSlots: {
      customRender: "pickBox",
    },
  },
  // {
  //   title: "任务类型",
  //   dataIndex: "pickType",
  //   key: "pickType",
  //   customRender: (text, record) => {
  //     return text == 0 ? "组合任务" : text == 1 ? "调拨任务" : "";
  //   },
  // },
  {
    title: "批次",
    dataIndex: "pkg",
    key: "pkg",
    scopedSlots: {
      customRender: "pkg",
    },
  },
  {
    title: "生成时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const taskColumns_delivery = [
  {
    title: "组合处理编号",
    dataIndex: "packCode",
    key: "packCode",
  },
  {
    title: "任务单号",
    dataIndex: "pickCode",
    key: "pickCode",
  },
  {
    title: "任务状态",
    dataIndex: "status",
    key: "status",
    customRender: (text, record) => {
      return text == 0 ? "未完成" : text == 1 ? "已完成" : "";
    },
  },
  {
    title: "任务类型",
    dataIndex: "pickType",
    key: "pickType",
    customRender: (text, record) => {
      return text == 0 ? "组合任务" : text == 1 ? "调拨任务" : "";
    },
  },
  {
    title: "生成时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: {
      customRender: "action",
    },
  },
];
export const taskGoodsColumns = [
  {
    title: "批次包编码",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    scopedSlots: {
      customRender: "img",
    },
  },
  {
    title: "商品sku",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "规格",
    dataIndex: "productProp",
    key: "productProp",
  },
  {
    title: "货格码",
    dataIndex: "gridCode",
    key: "gridCode",
  },
  {
    title: "数量",
    dataIndex: "useAmount",
    key: "useAmount",
  },
];
export const taskGoodsColumns_delivery = [
  {
    title: "批次包编码",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "图片",
    dataIndex: "productImg",
    key: "productImg",
    scopedSlots: {
      customRender: "img",
    },
  },
  {
    title: "商品sku",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "规格",
    dataIndex: "productProp",
    key: "productProp",
  },
  {
    title: "货格码",
    dataIndex: "gridCode",
    key: "gridCode",
  },
  {
    title: "数量",
    dataIndex: "amount",
    key: "amount",
  },
];
export const taskRecordsColumns = [
  {
    title: "拣货任务编号",
    dataIndex: "pickCode",
    key: "pickCode",
    width:200
  },
  // {
  //   title: "组合处理编号",
  //   dataIndex: "packCode",
  //   key: "packCode",
  //   width:200
  // },{
  //   title: "组合状态",
  //   dataIndex: "status",
  //   key: "status",
  //   width:100,
  //   customRender: (text, record) => {
  //     return text == 0 ? "操作中" : text == 1 ? "已完成" : "";
  //   },
  // },
  {
    title: "分拣框",
    dataIndex: "basketCode",
    key: "basketCode",
  },{
    title: "拣货任务商品数量",
    dataIndex: "pickNum",
    key: "pickNum",
    width:150,
  },
  // {
  //   title: "操作",
  //   dataIndex: "action",
  //   key: "5",
  //   scopedSlots: {
  //     customRender: "action",
  //   },
  // },
];


export const pickColumns = [
  {
    title: "拣货批次",
    dataIndex: "pickCode",
    key: "pickCode",
  },
  {
    title: "拣货数量",
    dataIndex: "nums",
    key: "nums",
  },
  {
    title: "是否拣货完成",
    dataIndex: "status",
    key: "status",
    customRender: (text, record) => {
      return {0:'拣货中',1:'已完成',2:'分拣中'}[text]
    },
  },
  // {
  //   title: "是否需要分拣",
  //   dataIndex: "needPick",
  //   key: "needPick",
  //   customRender: (text, record) => {
  //     return text === 0 ? "否" : text == 1 ? "是" : "-";
  //   },
  // },
  {
    title: "拣货库区",
    dataIndex: "regionName",
    key: "regionName",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    width:150,
    fixed:'right',
    scopedSlots: {
      customRender: "action",
    },
  }
]

export const pickDetailColumns = [
  {
    title: "商品图片",
    dataIndex: "pickCode",
    key: "pickCode",
  },
  {
    title: "批次号",
    dataIndex: "pickCode",
    key: "pickCode",
  },
  {
    title: "库位",
    dataIndex: "pickCode",
    key: "pickCode",
  },
  {
    title: "数量",
    dataIndex: "pickCode",
    key: "pickCode",
  },
]
